import { AUTH_MESSAGES, mapAuthError, readAuthError } from 'layouts/auth';

/**
 * Câu lỗi trang Đăng nhập (đặc tả §3.2). Backend (auth.service.ts + LocalAuthGuard) trả:
 * - 401 'Invalid Credentials' (email không có) / 401 'Unauthorized' (sai mật khẩu)
 * - 401 'This user account not verify' / 401 'This user account has been disabled'
 * - 429 ThrottlerException (20 request / 20 giây theo IP)
 */
export const LOGIN_MESSAGES = {
  // Hai lỗi 401 đầu dùng chung một câu (OWASP): không tiết lộ email có tồn tại hay không.
  invalidCredentials: 'Email hoặc mật khẩu không đúng. Vui lòng thử lại.',
  notVerified:
    'Tài khoản chưa xác minh email. Mở app HP Media để nhập mã xác minh, hoặc nhờ Admin hỗ trợ.',
  disabled: 'Tài khoản đang bị khóa. Liên hệ Admin để được hỗ trợ.',
  rateLimited: AUTH_MESSAGES.rateLimited,
  network: AUTH_MESSAGES.network,
  server: AUTH_MESSAGES.server,
  roleCheckFailed: 'Không kiểm tra được quyền của tài khoản. Vui lòng thử lại.',
} as const;

export function mapLoginError(error: unknown): string {
  const { status, serverMessage } = readAuthError(error);
  const text = serverMessage.toLowerCase();

  // "Chưa xác minh" và "bị khoá" hiện riêng: backend đã tự tiết lộ hai trạng thái này.
  if (text.includes('not verify')) return LOGIN_MESSAGES.notVerified;
  if (text.includes('disabled')) return LOGIN_MESSAGES.disabled;
  if (status === 401) return LOGIN_MESSAGES.invalidCredentials;

  // 429 / mất mạng / 5xx theo câu chung; lỗi lạ khác coi như hệ thống bận.
  return mapAuthError(error, { fallback: LOGIN_MESSAGES.server });
}
